import { Link } from "@tanstack/react-router";

const PROGRAM_LINKS = [
  { label: "Golf Ball Cannon", href: "https://t1dw.org/golf-ball-cannon" },
  { label: "Warrior Start", href: "https://warriorstart.t1dw.org" },
  { label: "Warrior Watch", href: "https://t1dw.org/warrior-watch" },
  { label: "Warrior Circle", href: "https://warriorcircle.t1dw.org" },
  { label: "Warrior Camp Scholarship", href: "https://t1dw.org/scholarships/camp" },
  { label: "Warrior College Scholarship", href: "https://t1dw.org/scholarships/college" },
];

export function SiteFooter() {
  return (
    <footer className="border-t border-white/10 bg-[oklch(0.14_0.035_230)]">
      <div className="mx-auto grid max-w-7xl gap-10 px-5 py-14 md:grid-cols-3">
        <div>
          <img src="/t1dw-logo-white.png" alt="T1D Warriors" className="h-10 w-auto" />
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-ice/80">
            Warrior Volunteer is the operations layer for people giving their time to T1D
            Warriors. The public mission lives at t1dw.org.
          </p>
        </div>

        <div>
          <p className="t-eyebrow">Programs</p>
          <ul className="mt-2 space-y-0.5 sm:mt-4 sm:space-y-2">
            {PROGRAM_LINKS.map((item) => (
              <li key={item.href}>
                <a
                  href={item.href}
                  target="_blank"
                  rel="noreferrer"
                  className="-mx-1 inline-flex min-h-11 items-center px-1 text-sm text-ice/85 transition-colors hover:text-cyan sm:min-h-0 sm:py-0"
                >
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="t-eyebrow">Volunteer</p>
          <ul className="mt-2 space-y-0.5 sm:mt-4 sm:space-y-2">
            <li>
              <Link
                to="/apply"
                className="-mx-1 inline-flex min-h-11 items-center px-1 text-sm text-ice/85 transition-colors hover:text-cyan sm:min-h-0"
              >
                Apply to volunteer
              </Link>
            </li>
            <li>
              <Link
                to="/auth"
                className="-mx-1 inline-flex min-h-11 items-center px-1 text-sm text-ice/85 transition-colors hover:text-cyan sm:min-h-0"
              >
                Volunteer sign in
              </Link>
            </li>
            <li>
              <a
                href="https://t1dw.org"
                target="_blank"
                rel="noreferrer"
                className="-mx-1 inline-flex min-h-11 items-center px-1 text-sm text-ice/85 transition-colors hover:text-cyan sm:min-h-0"
              >
                Main site
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="mx-auto flex max-w-7xl flex-col gap-2 px-5 py-5 text-sm text-ice/75 sm:flex-row sm:items-center sm:justify-between">
          <span>Copyright 2026 T1D Warriors. All rights reserved.</span>
          <span>Warrior Volunteer</span>
        </div>
      </div>
    </footer>
  );
}
